import styled, { css } from 'styled-components';

import { Col } from 'Components/Grid';

export const UpcomingEvent = styled.div`
    ${({ theme }) => css`
        margin-bottom: 2rem;

        @media ${theme.breakpoints.large.media} {
            margin-bottom: 3.5rem;
        }
    `}
`;

export const SideBox = styled.div`
    ${({ theme }) => css`
        position: relative;
        margin-bottom: 1.5rem;
        background: ${theme.colors.secondary.hex};
        border-radius: 0.5rem;
        text-align: center;
        padding-top: 0.75rem;

        @media ${theme.breakpoints.medium.media} {
            margin-bottom: 0;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 1.75rem;
        }
    `}
`;

export const SideBoxText = styled.p`
    ${({ theme }) => css`
        margin: 0;
        font-size: 1.125rem;
        font-weight: 700;
        line-height: 1.65;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.25rem;
        }
    `}
`;

export const SideBoxDate = styled.p`
    ${({ theme }) => css`
        margin: 0.5rem 0 1rem;
        font-size: 2rem;
        font-weight: 700;

        @media ${theme.breakpoints.large.media} {
            font-size: 2.25rem;
        }
    `}
`;

export const TextCol = styled(Col)`
    ${({ theme }) => css`
        order: 2;

        @media ${theme.breakpoints.medium.media} {
            order: 1;
        }
    `}
`;

export const EventCol = styled(Col)`
    ${({ theme }) => css`
        order: 1;

        @media ${theme.breakpoints.medium.media} {
            order: 2;
        }
    `}
`;
